import Image from "next/image";
import party from "party-js";
import { useEffect, type FC } from "react";

import Images from "styles/image-library";
import { Button } from "tw/components/atoms/Button";

export interface PromoBodyProps {
  promoIcon: string;
  promoTitle: string;
  promoSubtitle: string;
  promoButton: string;
  closeSettingsPopup: () => void;
}

export const PromoBody: FC<PromoBodyProps> = ({
  promoIcon,
  promoTitle,
  promoSubtitle,
  promoButton,
  closeSettingsPopup,
}) => {
  useEffect(() => {
    const imageElement = document.querySelector(
      ".confetti-target"
    ) as HTMLElement;
    if (imageElement) {
      party.confetti(imageElement, { count: 70 });
    }
  }, []);

  return (
    <div className="w-full flex flex-col md:pb-4">
      <div className="absolute h-[391px] w-[411px] self-center left-[50%] top-0 -translate-y-[45%] -translate-x-[45%] z-0 transition-opacity duration-500 opacity-100">
        <Image
          src={Images.ilustrations_highlight_background}
          alt="Highlight background"
          className="z-0"
          fill
        />
      </div>
      <Image
        src={promoIcon}
        height={64}
        width={64}
        alt="Input logo"
        className="confetti-target self-center z-10 mt-6 md:mt-0"
      />
      <p className="text-2xl md:text-[28px] text-center mt-6 mb-4 font-semibold">
        {promoTitle}
      </p>
      <p className="text-center text-secondary-text mb-6">{promoSubtitle}</p>
      <Button
        variant="primary"
        label={promoButton}
        onClick={closeSettingsPopup}
        className="min-w-full"
        leftIcon={
          <Image
            src={Images.icons_stake_arrow}
            width="20"
            height="20"
            alt="external"
          />
        }
      />
    </div>
  );
};
